import styled from 'styled-components';

export const StyledLink = styled.a`
  align-self: flex-end;
  font-weight: bold;
  margin-top: 24px;
  > span {
    color: #4c458a;
  }
`;

export const StyledShowMoreButton = styled.button`
  display: block;
  width: 141px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #4c458a;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 77px;
  margin-left: auto;
  margin-right: auto;
`;
